import moment from "moment"

export const renderMonthElement = ({ month, onMonthSelect, onYearSelect }: any) => {
  let i
  const years: any[] = []
  for (i = moment().year(); i >= moment().year() - 10; i--) {
    years.push(
      <option value={i} key={`year-${i}`}>
        {i}
      </option>,
    )
  }
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div style={{ paddingRight: "10px" }}>
        <select value={month.month()} onChange={e => onMonthSelect(month, e.target.value)}>
          {moment.months().map(label => (
            <option value={moment.months().indexOf(label)} key={`month-select-${label}`}>
              {label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <select value={month.year()} onChange={e => onYearSelect(month, e.target.value)}>
          {years}
        </select>
      </div>
    </div>
  )
}

export const isExpiredRecord = (date: string): boolean => moment(date)?.isBefore(moment(), "day")
